export default __webpack_public_path__ + "static/media/ingles_2.5105dc1e.jpg";